import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Tabs } from 'src/app/models/types/Tabs.type';

@Component({
  selector: 'app-tab-header',
  imports: [RouterModule],
  templateUrl: './tab-header.component.html',
  styleUrl: './tab-header.component.scss'
})
export class TabHeaderComponent {

  @Input('tabs') tabs!: Tabs;

  constructor() {
    if (!this.tabs) {
      this.tabs = [];
    }
  }

}
